export default "__VITE_ASSET__otelMHUi__"